import React from 'react'
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Paper, Typography } from "@material-ui/core";
import { Dashboard as DashboardLayout } from "layouts";
import SalesPendingBoatShow from './SalesPendingBoatShow';
import SalesBoatShowTab from './SalesBoatShowTab';
import SalesBoatShowAdd from './SalesBoatShowAdd';

const styles = theme => ({
    root: {
        padding: theme.spacing(4)
    }
});

function SalesBoatShow(classes) {
    return (
        <div>
            <DashboardLayout title="Boat Shows">
                <div className={classes.root + " sectionContainer"}>
                    <Typography
                        gutterBottom
                        variant="h2"
                        align="center"
                        className="title"
                    >
                        <span>Boat Shows</span>
                    </Typography>
                    <Paper style={{ margin: "3em" }}>
                        <div>
                            <Typography
                                gutterBottom
                                variant="h2"
                                align="center"
                                style={{
                                    fontSize: "20px",
                                    fontWeight: "300",
                                    textTransform: "uppercase",
                                    padding: "1em 0px"
                                }}
                            >
                                Pending Boat shows{" "}
                            </Typography>
                        </div>
                        <SalesPendingBoatShow />
                    </Paper>
                    <br />
                    <Paper style={{ margin: "3em",padding:"15px 0" }}>
                        <div className={classes.root}>
                            <SalesBoatShowAdd />
                        </div>
                    </Paper>
                    <br />
                    <Paper style={{ margin: "3em" }} className="salesboat-upcoming-pg">
                        <div>
                            <Typography
                                gutterBottom
                                variant="h2"
                                align="center"
                                style={{
                                    fontSize: "20px",
                                    fontWeight: "300",
                                    textTransform: "uppercase",
                                    padding: "1em 0px"
                                }}
                            >
                                All Upcoming Boat Shows
                            </Typography>
                            <SalesBoatShowTab />
                        </div>
                    </Paper>
                </div>
            </DashboardLayout>
        </div>
    )
}

SalesBoatShow.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SalesBoatShow);